<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-list" class="ag-grid-container">
    <div class="vx-card">
      <grid-panel
          height="md"
          :column-defs="columnDefs"
          :data="this.altCommercialProductList"
          :auto-size="true"
          @rowClicked="view"
          class="commercial-products-grid"
          @update:deleted="getAltCommercialProducts"
          ref="commercialProductsGrid"
          title="Commercial Products"
          @update:gridApi="(producerGridApi) => this.producerGridApi = producerGridApi"
          @rowSelected="onRowSelected"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span class="flex items-center" @click="addCommercialProduct" >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Add Commercial Product</span>
          </span>
        </vs-dropdown-item>
        <vs-dropdown-item v-if="componentAccess.canDelete.access">
          <span
              class="flex items-center"
              @click="removeSelected"
          >
            <feather-icon icon="MinusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Remove Selected</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>
    </div>

    <CommercialProductAddAlternativeModal
        :visible="modals.addCommercialProductModal.visible"
        :apiModel="this.companyTypeApiModel('commercialProductsIpr')"
        @updated="modalUpdated('addCommercialProductModal')"
        @close="closeModal('addCommercialProductModal')"
        @cancel="closeModal('addCommercialProductModal')"
        @error="modalError"
    />
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import CommercialProductAddAlternativeModal from "@/views/pages/commercial-products/CommercialProductAddAlternativeModal";
import IprProductCompanyTypeMixin from "@/components/mixins/IprProductCompanyTypeMixin";

export default {
  components: {
    TGrid,
    GridPanel,
    CommercialProductAddAlternativeModal,
  },
  mixins: [CellMatchingMixin, NotificationMixin, CanAccessMixin, IprProductCompanyTypeMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: `${this.ProductCompanyType}.commercial-products-ipr.alternative-commercial-products.edit`,
          access: false,
        },
        canDelete: {
          route: `${this.ProductCompanyType}.commercial-products-ipr.alternative-commercial-products.edit`,
          access: false,
        },
      },
      altCommercialProductList: [],
      searchQuery: '',
      producerGridApi: null,
      modals: {
        addCommercialProductModal: {
          visible: false
        },
      },
      selectedAltCommercialProductIds: [],

      // AgGrid
      columnDefs: [
        {
          headerName: '',
          minWidth: 80,
          maxWidth: 80,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellClass: 'flex',
        },
        {
          headerName: 'Commercial Product',
          field: 'CommercialProductName',
          filter: 'agTextColumnFilter',
          sort: 'asc',
        },
        {
          headerName: 'Risk Class',
          field: 'RiskCodeName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Sub Risk Class',
          field: 'SubRiskCodeName',
          filter: 'agTextColumnFilter',
        },
      ],
    }
  },
  methods: {
    async getAltCommercialProducts() {
      try {
        this.loading = true;
        const { data } = await this.$api[this.companyTypeApiModel('commercialProductsIpr')].getAlternativeCommercialProducts(this.$route.params.id);
        this.altCommercialProductList = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }

      return this.altCommercialProductList;
    },
    view({ data }) {
      // const id = data.CommercialProduct_PK || data.id;

      // this.$router.push({
      //   name: 'commercial-products.view',
      //   params: {id}
      // }).catch(() => {
      // });
    },
    addCommercialProduct() {
      this.openModal('addCommercialProductModal');
    },
    async modalUpdated(modalName) {
      if (modalName === 'addCommercialProductModal') {
        // This will reload the grid and update the counter
        await this.getAltCommercialProducts();
        console.log('test 123');
      }
      
      this.closeModal(modalName);
      this.notifySuccess('Alternative Commercial Product added successfully');
    },
    openModal(modalName) {
      this.modals[modalName].visible = true;
    },
    closeModal(modalName) {
      this.modals[modalName].visible = false;
    },
    modalError(errorMessage) {
      this.$vs.notify({
        color: 'danger',
        title: 'Error occurred',
        text: errorMessage,
        position: 'top-right'
      })
    },
    onRowSelected(event) {
      this.toggleProducerSelection(event);
    },
    toggleProducerSelection(params) {
      const isSelected = params.node.isSelected();

      if (isSelected && !this.selectedAltCommercialProductIds.includes(params.data.CommercialProduct_PK)) {
        this.selectedAltCommercialProductIds.push(params.data.CommercialProduct_PK);
      } 
      
      if (!isSelected) {
        this.selectedAltCommercialProductIds = this.selectedAltCommercialProductIds.filter(id => id !== params.data.CommercialProduct_PK);
      }
    },
    async removeSelected() {
      if (this.readOnly) {
        this.notifyError('You do not have permission to do this');
        return false;
      }

      if (!this.selectedAltCommercialProductIds.length) {
        this.notifyError('Please select at least one Commercial Product');

        return false;
      }

      const txt = this.selectedAltCommercialProductIds.length > 1 ? 'Commercial Products' : 'Commercial Product';

      try {
        this.selectedAltCommercialProductIds = [...new Set(this.selectedAltCommercialProductIds)];

        const { data } = await this.$api[this.companyTypeApiModel('commercialProductsIpr')].removeSelectedAlternativeCommercialProducts(this.$route.params.id, this.selectedAltCommercialProductIds);
        this.notifySuccess(`${txt} removed`);
        
        await this.getAltCommercialProducts();
      } catch (e) {
        this.notifyError(`Failed to remove ${txt}`);
        console.error(e)
      } finally {
      }
    },
  },
  async created() {
    await this.getAltCommercialProducts();
  },
}

</script>

<style lang="scss">

</style>
